import React, { useState } from "react";
import { Box, CircularProgress, Typography } from "@mui/material";
import { useNavigate } from 'react-router-dom';
import DataTable, { ColumnConfig, ColumnType } from '../../Shared/Components/DataTable';
import { BankAccountsRoutes } from '../../../Router/path';
import { BankAccount, useUpdateBankAccountMutation } from '../../BankAccounts';
import { useDeleteBankAccountMutation } from '../../BankAccounts/Service/bankAccountsApi';
import ActionButtons from '../../Shared/Components/ActionButtons';

import AccordionCard from '../../Shared/Components/AccordionCard/AccordionCard';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import { Booking } from '../../Shared/Types/bookingTypes';
import { useDeleteSelectedItems } from '../../Shared/Hooks/useDeleteSelectedItems';



interface CompanyAccountsBankProps {
    companyId: number;
    data: BankAccount[];
    isLoading: boolean;
    isError?: boolean;
    error?: any;
}



const CompanyAccountsBankTable: React.FC<CompanyAccountsBankProps> = ({ data, isLoading, isError, error }) => {
    const [editingRowId, setEditingRowId] = useState<number | null>(null);
    const [editedRow, setEditedRow] = useState<Partial<Booking>>({});
    const [selectedBankAccountsIds, setSelectedBankAccountsIds] = useState<
        number[]
    >([]);
    const [, setPage] = useState(0);
    const [, setRowsPerPage] = useState(10);
    const [updateBankAccount] = useUpdateBankAccountMutation();
    const [deleteBankAccount] = useDeleteBankAccountMutation();
    const navigate = useNavigate();
    const handleDeleteSelected = useDeleteSelectedItems<number>(
        selectedBankAccountsIds,
        (id) => deleteBankAccount(id).unwrap(),
        () => setSelectedBankAccountsIds([])
    );
    if (isLoading) {
        return <CircularProgress />;
    }

    if (isError) {
        return <Typography color="error">{(error as any)?.data?.message}</Typography>;
    }

    const columns: ColumnConfig<BankAccount>[] = [

        {
            key: "accountNumber",
            label: "Numer konta",
            editable: true,
            render: (row) => row.accountNumber,
        },
        {
            key: "bankName",
            label: "Nazwa banku",
            editable: true,
            render: (row) => row.bankName,
        },
        {
            key: "bankBranch",
            label: "Oddział banku",
            render: (row) => row.bankBranch,
            editable: true,
            type: ColumnType.text
        },
        {
            key: "currency",
            label: "Waluta",
            editable: true,
            type: ColumnType.text,
            parseValue: (val) => String(val),
        },
        {
            key: "description",
            label: "Opis",
            editable: true,
            type: ColumnType.text,
            render: (row) => row.description,
        },


    ];
    return (

        <AccordionCard title="Przypisane konta do firmy" icon={<AccountBalanceIcon fontSize="large" color="primary" />} >
            <Box sx={{ mt: 3 }}>
                <ActionButtons onDeleteSelected={handleDeleteSelected} />
            <DataTable
                columns={columns}
                data={data ?? []}
                isLoading={isLoading}
                isError={isError}
                errorMessage={(error as any)?.data?.message}
                getRowId={(row) => row.id}
                onEdit={(id) =>
                    navigate(BankAccountsRoutes.update.replace(":bankAccountId", id.toString()))
                }
                onPageChange={setPage}
                onRowsPerPageChange={(newSize) => {
                    setRowsPerPage(newSize);
                    setPage(0);
                }}
                    selected={selectedBankAccountsIds}
                    onSelectionChange={setSelectedBankAccountsIds}
                editingRowId={editingRowId}
                setEditingRowId={setEditingRowId}
                editedRow={editedRow}
                setEditedRow={setEditedRow}
                onInlineSave={async (updatedRow) => {
                    await updateBankAccount({ id: updatedRow.id, data: updatedRow }).unwrap();
                    setEditingRowId(null);
                    setEditedRow({});
                }}
            />
        </Box>
        </AccordionCard >

    );
};

export default CompanyAccountsBankTable;


